<template>
  <outlined-block title="Supplier specific costing" :rules="[valid,costingValid]" @click="selectedIndex = -1" v-if="supplierAccess">
    <v-form v-model="valid" ref="form">
      <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                    :items="vendors" no-data-text="No supplier costs" class="no-sort"
                    :headers="[{text:'',value:'add',width:'5%',align:'center',cellClass:'pa-0',divider:true},
                              {text: 'Supplier', value: 'vendor', width:'40%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'},
                              {text: 'Item #', value: 'item' ,width:'15%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'},
                              {text: units + ' cost', value: 'cost' ,width:'15%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt',align:'right'},
                              {text: 'Tax', value: 'taxes' ,width:'25%',divider:true,class:'px-2',cellClass:'py-2 px-1 pt'}]"
                    @click.native.stop=""
                    :item-class="item => vendors.indexOf(item)=== selectedIndex ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                    @click:row="item => {selectedIndex = vendors.indexOf(item); $nextTick(() => this.$refs.form.validate())}">
        <template v-slot:item.add="{index}">
          <v-btn class="mt-n2" icon @click.stop="deleteVendor(index)"><v-icon small>mdi-delete</v-icon></v-btn>
        </template>
        <template v-slot:item.vendor="{item,index}">
          <v-autocomplete v-if="selectedIndex === index" dense outlined label="Supplier" v-model="item.vendorId" :items="allVendors" item-value="id" item-text="name" class="text-body-2" no-data-text="No suppliers found" :rules="[fieldRules.required]">
            <template v-slot:prepend-item>
              <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="suppliersItem=item;supplierCreate=true">
                <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new supplier
              </div>
            </template>
          </v-autocomplete>
          <div v-else class="ml-1" :class="{'error--text':!item.vendorId}">
            <template v-if="!item.vendorId">Required</template>
            <template v-else>{{vendorName(item.vendorId)}}</template>
          </div>
        </template>
        <template v-slot:item.item="{item,index}">
          <v-text-field v-if="selectedIndex === index" dense outlined label="Item #" v-model="item.sku" class="text-body-2" :rules="[fieldRules.maxLength(20)]"/>
          <div v-else class="ml-1">{{item.sku}}</div>
        </template>
        <template v-slot:item.cost="{item,index}">
          <decimal-number-input v-if="selectedIndex === index" label="Cost" outlined v-model="item.cost" :precision="4" class="text-body-2"/>
          <div v-else class="mr-1" :class="{'error--text':item.cost < 0}">${{item.cost | number(4)}}</div>
        </template>
        <template v-slot:item.taxes="{item,index}">
          <v-autocomplete v-if="selectedIndex === index" outlined dense label="Taxes" v-model="item.taxId" :items="taxes" item-value="id" item-text="name" class="text-body-2"/>
          <div v-else class="ml-1">{{taxName(item.taxId)}}</div>
        </template>
        <template v-slot:body.append="{headers}">
          <tr class="no-hover" @click="selectedIndex = -1">
            <td class="text-center">
              <v-btn fab color="primary" x-small @click.stop="addVendor"><v-icon small>mdi-plus</v-icon></v-btn>
            </td>
            <td :colspan="headers.length-1"/>
          </tr>
        </template>
      </v-data-table>
    </v-form>
    <supplier-quick-create v-model="supplierCreate" @create="newSupplier" :suppliesInBond="suppliesInBond"/>
  </outlined-block>
</template>

<script>
import SupplierQuickCreate from '@/views/purchasing/suppliers/SupplierQuickCreate'

export default {
  name: 'SupplierCosting',
  components: {SupplierQuickCreate},
  props: {
    vendors: {type:Array,required:true},
    allVendors: {type:Array,required:true},
    taxes: {type:Array, required:true},
    defaultSku: {type:String, required:false, default:''},
    units: {type:String,required:false, default:'Unit'},
    suppliesInBond: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      valid: true,
      suppliersItem: null,
      supplierCreate: false,
      selectedIndex: -1
    }
  },
  computed: {
    costingValid() {
      return this.vendors.every(vendor => !!vendor.vendorId && vendor.cost >= 0);
    },
    supplierAccess() {
      return this.$store.getters.company.permissions.includes('buying');
    }
  },
  methods: {
    vendorName(vendorId) {
      return this.allVendors.find(vendor => vendor.id === vendorId)?.name;
    },
    taxName(taxId) {
      return this.taxes.find(tax => tax.id === taxId)?.name;
    },
    newSupplier(vendor) {
      this.allVendors.push(vendor);
      this.suppliersItem.vendorId = vendor.id;
    },
    addVendor() {
      this.vendors.push({vendorId:'',sku:this.defaultSku, cost:0, taxId:null});
      this.selectedIndex = this.vendors.length  - 1;
      this.$nextTick(() => this.$refs.form.validate())
    },
    deleteVendor(index) {
      this.vendors.splice(index, 1);
      this.selectedIndex = - 1;
    }
  }
}
</script>